import { render } from "./NomenclatureView.vue?vue&type=template&id=1756c04b&scoped=true"
import script from "./NomenclatureView.vue?vue&type=script&lang=js"
export * from "./NomenclatureView.vue?vue&type=script&lang=js"

import "./NomenclatureView.vue?vue&type=style&index=0&id=1756c04b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1756c04b"]])

export default __exports__